var DEFAULT_COUNTRY_CODE = 'us';

module.exports = {
	setup_intl_tel_input: function (inputSelector, valueSelector, dialCodeSelector, countrySelector) {
		const $input = window.jQuery(inputSelector);
		const _input = document.querySelector(inputSelector);
		if (!_input){
			console.log(`Phone input ${inputSelector} was not found. \\n Phone number select will not work`);
		}
		const defaultCountry = window.jQuery(countrySelector).data('defaultcountrycode')
			? window.jQuery(countrySelector).data('defaultcountrycode').toLowerCase()
			: DEFAULT_COUNTRY_CODE;

		const countryVal = window.jQuery(countrySelector).val();
		const countryNotBlank = countryVal !== '' && countryVal !== undefined;
		const initialCountry = countryNotBlank ? countryVal : defaultCountry;
		const iti = window.intlTelInput(_input, {
			initialCountry: initialCountry,
			utilsScript: '/admin/assets/js/libs/intlTelInput-utils.js'
		});

		$input.on('blur', function () {
			const phone = cleanPhoneNumber(inputSelector);
			window.jQuery(valueSelector).val(phone.number);
			window.jQuery(dialCodeSelector).val(phone.dialCode);
			window.jQuery(countrySelector).val(phone.countryCode);
		});
		_input.addEventListener('countrychange', () => {
			const countryData = iti.getSelectedCountryData();
			const phone = cleanPhoneNumber(inputSelector);
			window.jQuery(dialCodeSelector).val(phone.dialCode);
			window.jQuery(countrySelector).val(countryData.iso2);
		});
	}
};

function cleanPhoneNumber(selector) {
	var iti = window.intlTelInputGlobals.getInstance(document.querySelector(selector));
	var intlData = iti.getSelectedCountryData();

	var userEnteredValue = iti.getNumber();
	var countryCode = intlData.iso2;
	var dialCode = intlData.dialCode;

	var dialCodeLen = typeof dialCode === 'undefined' ? 0 : dialCode.toString().length;
	var firstN = userEnteredValue.substring(0, dialCodeLen + 1);
	var cleanedNumber = userEnteredValue;
	var lenWithoutDialCode = userEnteredValue.length - dialCodeLen - 1;

	//make sure dial code only appears once in the final number
	if (firstN === '+' + dialCode) {
		cleanedNumber = userEnteredValue.slice(-1 * lenWithoutDialCode);
	}

	return {
		dialCode: dialCode,
		countryCode: countryCode,
		number: cleanedNumber
	};
}
